export function createOffcanvasHandlers(component) {
    return {
        offcanvasTriggerClick: () => {
            if (!component.isCustomerLoggedIn) {
                component.startWidgetIfNotAlreadyDone()
            }
        },
        offcanvasState: (event) => {
                if (event.detail &&
                    event.detail.activeOffCanvas === 'login' &&
                    !component.isCustomerLoggedIn
                ) {
                component.startWidgetIfNotAlreadyDone()
            }
        }
    }
}

const offcanvasLogin = {
    attachOffcanvasStart() {
        if (!this.config.offcanvasStart || !this.widget || this.offcanvasHandlersAttached) {
            return
        }

        this.offcanvasLoginTrigger = document.querySelector('.mey-offcanvas-login-trigger')
        this.boundHandlers = {
            ...this.boundHandlers,
            ...createOffcanvasHandlers(this)
        }

        if (this.offcanvasLoginTrigger) {
            this.offcanvasLoginTrigger.addEventListener('click', this.boundHandlers.offcanvasTriggerClick)
        }

        window.addEventListener('offcanvas-state', this.boundHandlers.offcanvasState)
        this.offcanvasHandlersAttached = true
    },

    detachOffcanvasStart() {
        if (this.offcanvasLoginTrigger && this.boundHandlers.offcanvasTriggerClick) {
            this.offcanvasLoginTrigger.removeEventListener('click', this.boundHandlers.offcanvasTriggerClick)
        }

        if (this.boundHandlers.offcanvasState) {
            window.removeEventListener('offcanvas-state', this.boundHandlers.offcanvasState)
        }

        this.offcanvasHandlersAttached = false
    }
}

export default offcanvasLogin
